import { FormHookResult, SearchableDropDown } from 'design-system';
import CatalogItem from 'src/models/helperTypes/CatalogItem';

function makeSearchableDropDown(
  id: string,
  label: string,
  key: string,
  data: Array<CatalogItem>,
  onChange: (val: CatalogItem) => void,
  getInputProps: FormHookResult,
  disable = false,
): JSX.Element {
  return (
    <SearchableDropDown
      inputId={id}
      inputName={key}
      inputLabel={label}
      defaultValue={getInputProps(key).value as string}
      options={data}
      inputError={getInputProps(key).error}
      inputErrorMessage={getInputProps(key).errorText}
      isDisabled={disable}
      onChange={onChange}
    />
  );
}

export default makeSearchableDropDown;
